export const SubmitPaymentForm = (rawHtml: string): void => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(rawHtml, 'text/html');
    const backendForm = doc.querySelector('form');
    if (!backendForm) {
        return;
    }
    const form = document.createElement('form');
    form.method = backendForm.method || 'POST';
    form.action = backendForm.action;

    backendForm.querySelectorAll<HTMLInputElement>('input').forEach(input => {
        const field = document.createElement('input');
        field.type = input.type;
        field.name = input.name;
        field.value = input.value;
        form.appendChild(field);
    });

    document.body.appendChild(form);
    form.submit();
};
